<template>
    <div ref="tableContainer" class="w-full">
        <vx-input-group class="w-full">
            <vs-input
                ref="refInput"
                v-bind="$attrs"
                @focus="focus"
                @blur="blur"
                :style="`height: ${input_height}px`"
                icon-no-border
                :icon="icon"
                size="large"
                :maxlength="inputMaxLimit"
                icon-pack="feather"
                :placeholder="$t(placeholder)"
                :value="searchQuery"
                @input="studentSearch"
                class="vs-input-no-border vs-input-no-shdow-focus w-full table_container" />
            <template slot="append">
                <div class="append-text btn-addon">
                    <vs-button
                        v-if="show_icon_clear"
                        @click="clearSearch()"
                        :disabled="clearSearchDisabled"
                        color="dark"
                        type="flat"
                        class="rounded"
                        icon-pack="feather"
                        icon="icon-x">
                    </vs-button>
                </div>
            </template>
        </vx-input-group>
<!--        <Dropdownx ref="refDropdownx" :leftx="leftx" :topx="topx">-->
<!--            <Filters ref="refFilters" :horizontal="true" :filters="filters" @updateData="updateData"/>-->
<!--        </Dropdownx>-->
    </div>

</template>

<script>
import Dropdownx from "@/pages/Home/ListGlobalComponents/dropdown/Dropdownx";
import Filters from "@/pages/Home/ListGlobalComponents/Filters";
// Создаем переменную таймера глобально
let searchId;
export default {
    name: "Search",
    components:{
        Dropdownx,
        Filters,
    },
    props:{
        inputMaxLimit: {
            type: Number,
            default:100,
            required:false,
        },
        placeholder:{
            type: String,
            default:'search',
            required:false,
        },
        input_height:{
            type:String,
            default:'auto',
        },
        show_icon_clear:{
            type:Boolean,
            default:true,
        },
        dropdown_filter:{
            type:Boolean,
            default:false,
        },
        filters:{
            type: Array,
        },
        icon:{
            type:String,
            default:'icon-search',
        },
        query_name:{
            type:String,
            default:'search',
        },

    },
    created() {
        this.searchAggregate()
    },
    data: () => ({
        dropdownVisible: false,
        leftAfter: 20,
        leftx: 0,
        topx: 0,
    }),
    computed:{
        searchQuery: {
            get () {
                return this.$route.query[this.query_name]
            },
            set (val) {
                // this.$store.commit('student_list/SET_SEARCH_QUERY', val)
            }
        },
        clearSearchDisabled() {
            // Делаем активной/не активной кнопку стереть запрос на фио пользователя
            if(this.$route.query[this.query_name]) return false
            else return true
        }
    },
    mounted() {
        document.addEventListener('click', this.clickx)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.clickx)
    },
    methods:{
        searchAggregate() {
            // Если в строке браузера есть ключ search то подставляем от туда данные в поле поиска
            if(Object.keys(this.$route.query).includes(this.query_name)){
                if(this.$route.query[this.query_name].length <= this.inputMaxLimit)
                    this.searchQuery = this.$route.query[this.query_name]
                else {
                    let query = Object.assign({}, this.$route.query)
                    delete query[this.query_name]
                    this.$router.push({query})
                }
            }
        },
        async studentSearch(e) {
            if (String(e).length <= this.inputMaxLimit) {
                this.searchQuery = e
                let query = Object.assign({}, this.$route.query)
                // Подменяем query в роуте на введенные в строку для поиска данные, проверяем что введенные данные не пустые
                if(e.length > 0) {
                    query[this.query_name] = e
                } else if(Object.keys(this.$route.query).includes(this.query_name)) {
                    delete query[this.query_name]
                }

                // Не успевал поставить в роут, сделал await
                await this.$router.push({query})
                // Очищаем таймер
                clearTimeout(searchId);

                // Создаем таймер при завершении которого отправляем запрос к серверу
                searchId = setTimeout(async () => {
                    this.$emit('updateData')
                }, 400);
            }
        },
        async clearSearch() {
            // Стираем строку запроса фио
            let query = Object.assign({}, this.$route.query)

            if(Object.keys(this.$route.query).includes(this.query_name)) {
                this.searchQuery = ''
                delete query[this.query_name]
                // Не успевал поставить в роут, сделал await
                await this.$router.push({query})
                this.$emit('updateData')
            }
        },
        blur(val){
            this.$emit('blur', val)
        },
        focus(val){
            if (this.dropdown_filter){
                this.$refs.refDropdownx._data.dropdownVisible = true
                this.$nextTick(() => {
                    this.changePositionMenu()
                })
            }


            this.$emit('focus', val)
        },
        changePositionMenu() {
            // let [dropdownMenu] = this.$children.filter(item => item.hasOwnProperty('dropdownVisible'))
            // let scrollTopx = window.pageYOffset || document.documentElement.scrollTop;
            // const elements = document.getElementsByClassName('con-vs-dropdown--menu');
            // const element = elements[0]; // Предполагаем, что элемент единственный на странице
            // const length = element.clientWidth; // Получаем длину элемента в пикселях
            const currentDateCell = this.$el.querySelector('.con-vs-dropdown--menu');
            const icon_inputx = this.$el.querySelector('.icon-inputx');
            if (currentDateCell && !this.leftx) {
                // Получение контейнера таблицы
                const tableContainer = this.$refs.tableContainer;


                // let offsetright = window.innerWidth - currentDateCell.offsetLeft - icon_inputx.getBoundingClientRect().right
                let offsetright = currentDateCell.getBoundingClientRect().right + icon_inputx.getBoundingClientRect().right
                // Вычисление позиции прокрутки с учетом закрепленного столбца
                // const scrollLeft = offsetright + this.$refs.refInput.$el.getBoundingClientRect().left  + currentDateCell.clientWidth/2  - tableContainer.clientWidth/2;


                const scrollLeft = offsetright

                // Установка позиции прокрутки
                this.leftx = scrollLeft
            }



            // this.topx = (this.$refs.refInput.$el.getBoundingClientRect().top - this.$refs.refInput.$el.clientHeight - 7) + scrollTopx
            // this.leftx = this.$refs.refInput.$el.getBoundingClientRect().left + 7

        },
        clickx(evt) {
            if (!evt.target.closest('.vs-dropdown--menu') && !evt.target.closest('.table_container')) {
                this.$refs.refDropdownx._data.dropdownVisible = false
                this.leftx = 0
            }
        },
        updateData(){
            this.$emit('updateData')
        }
    }
};
</script>

<style scoped>

</style>
